import React, {useState, useEffect} from 'react';
import Viewer from 'react-viewer';
import Map from './Map';
import Card from 'react-bootstrap/Card';
import {Form, Modal} from 'react-bootstrap';
// import Switch from 'react-bootstrap-switch';
import ClockLoader from 'react-spinners/ClockLoader';
export default function MapAndInfo(props) {
  //   const [allow, setAllow] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [center, setCenter] = useState(null);
  const [image, setImage] = useState([{src: '', alt: ''}]);
  const [url, setUrl] = useState('');
  const [visible, setVisible] = React.useState(false);
  const [showMd, setShowMd] = React.useState(false);
  //   useEffect(() => {
  //     if (props.places) {
  //       setAllow(props.item.agreeExpend);
  //     }
  //   }, [props.places]);

  const getVdoWs = async (url) => {
    try {
      setLoading(true);
      console.log(url);
      let vdos = await props.getVdoWs(url);
      vdos = vdos
        .filter((e) => e.zoom_vdo_type === 'active_speaker')
        .filter((e) => e.value === '1');
      if (vdos.length > 0) {
        setUrl(vdos[0].zoom_play_url);
      } else {
        setUrl(`https://api-passport.advanceagro.net/404.html`);
      }
      setLoading(false);
    } catch (error) {}
  };

  // 1. ดึงค่าออกมาเตรียมไว้ (แปลงเป็น Number เพื่อความชัวร์)
  const planDistance = props.item ? Number(props.item.distance / 1000) : 0; // แผน (Km)
  const actualDistance = props.plan ? Number(props.plan.distanceActual) : 0; // จริง (Km)

  // 2. เช็คเงื่อนไข: จริง > (แผน + 20%)
  const isOverDistance = actualDistance > planDistance * 1.2;

  return (
    <div className="row">
      {/* Modal สำหรับ Zoom VDO */}
      <Modal size={'lg'} show={showMd} onHide={() => setShowMd(false)}>
        <div className={isLoading ? 'overlay dark' : 'd-none'}>
          <ClockLoader color="#c4c4c4" size="50" />
        </div>
        <Modal.Header closeButton>Zoom VDO</Modal.Header>
        <Modal.Body>
          <div className="container row m-0">
            <iframe
              src={url}
              height={'520px'}
              width={'100%'}
              frameBorder={0}
              title="Zoom Video"
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* Image Viewer */}
      <Viewer
        zoomSpeed={0.2}
        zIndex={9999}
        visible={visible}
        onClose={() => setVisible(false)}
        images={image}
      />

      {/* --- ส่วนข้อมูลด้านบน --- */}
      <div className="row col-12 m-0 p-0">
        <Form.Group className="col-md-3" style={{minHeight: '85px'}}>
          {' '}
          {/* จองความสูงไว้คงที่ */}
          <Form.Label>ระยะ (Km.)</Form.Label>
          <div style={{position: 'relative'}}>
            {' '}
            {/* ครอบไว้เพื่อคุมตำแหน่ง */}
            <Form.Control
              type="text"
              className={
                props.type !== 'plan' && isOverDistance ? 'is-invalid' : ''
              }
              value={
                props.item
                  ? props.type === 'plan'
                    ? planDistance.toFixed(2)
                    : actualDistance.toFixed(2)
                  : '0'
              }
              disabled={
                props.item ? (props.type === 'plan' ? true : !props.show) : true
              }
              onChange={(e) => props.onChangeKm(e.target.value)}
            />
            {/* ปรับตำแหน่ง Text ให้ไม่ไปดัน Map */}
            {props.type !== 'plan' && isOverDistance && (
              <Form.Control.Feedback
                type="invalid"
                style={{
                  fontSize: '11px',
                  position: 'absolute', // ทำให้มันลอยอยู่ ไม่ไปดัน Layout ตัวอื่นลง
                  top: '100%',
                  left: 0,
                  whiteSpace: 'nowrap' // ป้องกันตัวหนังสือขึ้นบรรทัดใหม่จนไปทับอย่างอื่น
                }}
              >
                ⚠️ เกินแผน 20% (แผน: {planDistance.toFixed(2)})
              </Form.Control.Feedback>
            )}
          </div>
        </Form.Group>

        <Form.Group className="col-md-3">
          <Form.Label>คำนวณ (฿)</Form.Label>
          <Form.Control
            type="text"
            value={
              props.item
                ? props.type === 'plan'
                  ? `${props.item.totaCost.toFixed(2)}`
                  : `${props.plan.totaCostActual.toFixed(2)}`
                : '0'
            }
            disabled
          />
        </Form.Group>

        <Form.Group className={props.type === 'plan' ? 'col-md-2' : 'd-none'}>
          <Form.Label>เรท</Form.Label>
          <Form.Control
            type="text"
            disabled
            value={props.item ? `${props.item.rate}` : '0'}
          />
        </Form.Group>

        <Form.Group className={props.type === 'plan' ? 'd-none' : 'col-md-2'}>
          <Form.Label>&nbsp;</Form.Label>
          <button
            disabled={!props.show}
            className="btn btn-primary col-md-12"
            onClick={props.onRecal}
          >
            Recal
          </button>
        </Form.Group>

        <Form.Group className="col-md-4">
          <Form.Label>ค่าใช้จ่ายอื่นๆ</Form.Label>
          {props.type === 'plan' ? (
            <Form.Control type="text" disabled value={props.expend} />
          ) : (
            <button
              disabled={!props.show}
              className="btn btn-primary col-md-12"
              onClick={props.onAdjust}
            >
              Adjust
            </button>
          )}
        </Form.Group>
      </div>

      {/* --- ส่วนของแผนที่ --- */}
      <div
        className="col-12"
        style={{
          height: '45vh',
          width: '100%',
          paddingBottom: '5vh',
          minHeight: '300px' // กันแผนที่หายกรณี parent สูง 0
        }}
      >
        <Map
          places={props.places || []}
          center={center}
          // ใช้ Key ที่นิ่งขึ้น หรือเช็ค props.item.planid ให้ชัวร์
          key={props.item?.planid ? `map-${props.item.planid}` : 'map-default'}
        />
      </div>

      {/* --- ส่วนรายการด้านล่าง --- */}
      <div className="col-12">
        <Card className="card-primary">
          <div
            className="container"
            style={{
              height: '42vh',
              width: '100%',
              overflowY: 'scroll'
            }}
          >
            {props.places &&
              props.places.map((e, index, array) => (
                <div className="col-12 mt-2" key={`b-${index}`}>
                  <div className="info-box-drag">
                    <div className="row">
                      <span className="info-box-icon">
                        <div className="numberCircle">
                          {array.length > 24
                            ? index + 1
                            : String.fromCharCode(index + 65)}
                        </div>
                      </span>
                      <div className="info-box-content2">
                        {e.image && (
                          <img
                            style={{cursor: 'pointer'}}
                            className="car-img3 ml-1"
                            src={e.image}
                            alt="location"
                            onClick={() => {
                              if (e.alt === 'Zoom') {
                                setShowMd(true);
                                getVdoWs(e.downloadUrl);
                              } else {
                                setVisible(true);
                                setImage([{src: e.image, alt: ''}]);
                              }
                            }}
                          />
                        )}
                      </div>
                      <div className="info-box-content col-4">
                        <span
                          onClick={() => setCenter({lat: e.lat, lng: e.lng})}
                          className="info-box-text"
                          style={{cursor: 'pointer'}}
                        >
                          {`${Number(e.lat).toFixed(4)} , ${Number(
                            e.lng
                          ).toFixed(4)}`}
                        </span>
                        <span className="info-box-text">{e.datetime}</span>
                      </div>
                      <div className="info-box-content col-6">
                        <textarea
                          className="form-control col-12"
                          style={{fontSize: 12}}
                          rows={3}
                          defaultValue={e.name}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
